const config = {
    id: 23,
    name: "底部悬浮",
    type: 1,
    module_code: "bottom_float",
    icon: "icon-tms-bottom_nav",
    font_icon: "&#xe652;",
    style_type: 1,
    link_type: 1,
    link_data: [{
        memo: "建议尺寸:750px*184px"
    }],
    property_data: {
        radius: 5,
        distance: 10,
        margin: 10
    }
};
export default config;